import React, { useState } from "react";
import PropTypes from "prop-types";
import { useApolloClient } from "@apollo/client";

import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import useAuth from "../hooks/useAuth";
import UserAvatar from "./userAvatar";

import ExitIcon from "assets/svg/exit.svg";

const UserPopup = ({ userInfo }) => {
  const { signOut } = useAuth();
  const client = useApolloClient();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const popoverId = open ? "user-popover" : undefined;

  const handleOpenPopover = (event) => setAnchorEl(event.currentTarget);
  const handleClosePopover = () => setAnchorEl(null);

  const handleSignOut = async () => {
    try {
      if (typeof signOut === "function") signOut();
      if (client && typeof client.clearStore === "function")
        await client.clearStore();
    } catch (err) {
      // optionally log the error
    } finally {
      handleClosePopover();
    }
  };

  const firstName = userInfo?.firstName || "";
  const lastName = userInfo?.lastName || "";
  const fullName = `${firstName} ${lastName}`.trim();
  const email = userInfo?.email || "";

  return (
    <>
      <div
        style={{ cursor: "pointer" }}
        onClick={handleOpenPopover}
        className="user-button-text-container"
      >
        <UserAvatar
          Icon={userInfo.name}
          userId={userInfo.userId}
          variant="rounded"
          sx={{ width: 40, height: 40, fontSize: "20px" }}
        />
      </div>
      <Popover
        id={popoverId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        closeAfterTransition={true}
        anchorPosition={{ top: 0, left: 0 }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            elevation: 1,
            sx: { borderRadius: "28px", margin: "20px", minWidth: "330px" },
          },
        }}
      >
        <Stack
          padding="16px 24px"
          direction="row"
          gap="24px"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack gap="16px" direction="row">
            <UserAvatar
              Icon={userInfo.name}
              userId={userInfo.userId}
              variant="rounded"
              sx={{ width: 40, height: 40, fontSize: "20px" }}
            />
            <Stack>
              <Typography variant="subtitle1">{fullName}</Typography>
              <Typography variant="body2">{email}</Typography>
            </Stack>
          </Stack>
          <IconButton variant="filled" onClick={handleSignOut}>
            <ExitIcon width="20px" />
          </IconButton>
        </Stack>
      </Popover>
    </>
  );
};

UserPopup.propTypes = {
  userInfo: PropTypes.shape({
    name: PropTypes.string,
    userId: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }),
};

UserPopup.defaultProps = {
  userInfo: {},
};

export default UserPopup;
